export default {

    StatesAndCities: {
      GetAll: '/api/states-and-cities/',
    },

    Posts: {
        GetLatest: '/api/posts/latest?lang=@lang@&profile=@profile@&lang=@lang@',
        GetTaxonomyPosts: '/api/posts/byTaxonomy?lang=@lang@&profile=@profile@&lang=@lang@&tags=@taxonomy@&types=@types@',
        GetFeatured: '/api/posts/featured?lang=@lang@&profile=@profile@&tags=@tags@',
    },

    Products: {
        GetFeaturedProducts: '/api/products/featured?lang=@lang@&tags=@tags@&products=@products@',
        GetProductsBySearchPage: '/api/products/search/@tagslug@/@page@?profile=@profile@',
    },

    Related: {
        GetRelatedContent: '/api/related/@page_id@?type=@type@&max=@max@&lang=@lang@&profile=@profile@'
    },

    Content: {
        AutocompleteByName: '/api/content/autocomplete?q=@query@&lang=@lang@',
        FetchAllWithType: '/api/content/@page_type@?page=@page@&q=@search_terms@&max=@max@&sort=@sort@&lang=@lang@',
        FetchAllWithTypeAndTaxonomy: '/api/content/taxonomy/@page_type@?taxonomy=@taxonomy@&page=@page@&max=@max@&lang=@lang@&profile=@profile@&q=@query@&sort=@sort@&l=@letter@&excluded_tags=@excluded_tags@',
        FetchAllPodcasts: '/api/content/podcasts/?page=@page@&max=@max@&lang=@lang@&profile=@profile@&q=@query@&sort=@sort@'
    },

    Courses: {
        SubmitEnrollment: '/instituto-eurofarma/cursos-de-formacao/inscricoes'
    },

    Forms: {
        Submit: '/api/forms/@form_id@/submit',
    },

    Waitlist: {
        Submit: '/api/waitlist/submit',
    },

    UsefulContent: {
        Register: '/userful-content/register'
    },

    HealthcareOverride: {
        Submit: '/api/save-healthcare-override/@pageType@',
    },

    CrmValidation: {
        Submit: '/api/validate-crm/@crm@/@uf@',
    }

};
